/*** IMPORTS FROM imports-loader ***/
(function() {

define([
	'jquery',
	'pip-model',
	'mustache'
],
function(
	$,
	pip,
	mustache
){
	var view = {
		selectors: {
			richContent: '.rich-content-container .content',
			wrapper: '.rich-content-mobile-wrapper'
		},
		template: {
			richTemplate: $('#rich-content-mobile').html()
		},
		updateDOM: {
			richContent: function () {
				$(view.selectors.richContent).filter(function() {
					return !$(this).children().length;
				}).hide();
			},
			lazyLoadContent: function () {
				$(view.selectors.wrapper).html(mustache.render(view.template.richTemplate));
			}
		}
	}

	return {
		init: function init() {
			if(pip.platform === 'MOBILE' && pip.features.richContentMobileEnabled) {
				view.updateDOM.lazyLoadContent();
			}
			view.updateDOM.richContent();
		}
	};
});

}.call(window));